"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseField = function (_Component) {
	_inherits(BaseField, _Component);

	function BaseField(props) {
		_classCallCheck(this, BaseField);

		var _this = _possibleConstructorReturn(this, (BaseField.__proto__ || Object.getPrototypeOf(BaseField)).call(this, props));

		_this.state = { value: void 0 };
		return _this;
	}

	_createClass(BaseField, [{
		key: "getValue",
		value: function getValue() {
			var V0 = this.state.value === void 0 ? this.props.value : this.state.value;
			if (V0 === void 0 || V0 === null || V0 === "") V0 = this.defaultValue;
			return V0;
		}
	}, {
		key: "updateValue",
		value: function updateValue(value, commitNow) {
			if (this.props.realtime || commitNow) this.commitValue(value);else this.setState({ value: value });
		}
	}, {
		key: "commitValue",
		value: function commitValue(value) {
			if (this.commitTimeout) {
				clearTimeout(this.commitTimeout);
				delete this.commitTimeout;
			}

			var v = value === void 0 ? this.getValue() : value;
			this.props.setValue(v);
			this.setState({ value: void 0 });
		}
	}, {
		key: "componentDidUpdate",
		value: function componentDidUpdate() {
			var _this2 = this;

			if (!this.commitTimeout && this.state.value) {
				this.commitTimeout = setTimeout(function () {
					delete _this2.commitTimeout;
					if (_this2.state.value) _this2.commitValue();
				}, 250);
			}
		}
	}, {
		key: "defaultValue",
		get: function get() {
			return "";
		}
	}]);

	return BaseField;
}(_react.Component);

exports.default = BaseField;